import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import FolderOpenRoundedIcon from '@mui/icons-material/FolderOpenRounded';

import { Section, SectionHeading, Panel, Reveal } from '../components/ui';
import { TYPE } from '../theme/tokens';

// Ruta /projects există, dar nu e încă în meniu: pagina spune deschis că
// lista se completează, în loc să lase un ecran gol cu un titlu pe el.
export default function Projects() {
  const { t } = useTranslation();

  return (
    <Section first component="header">
      <SectionHeading
        component="h1"
        align="center"
        eyebrow={t('projects.eyebrow')}
        title={t('projects.title')}
        lede={t('projects.subtitle')}
        titleSx={TYPE.h1}
      />

      <Reveal delay={0.1} sx={{ maxWidth: 620, mx: 'auto', mt: { xs: 5, md: 7 } }}>
        <Panel sx={{ textAlign: 'center' }} bodySx={{ px: { xs: 3, md: 5 }, py: { xs: 5, md: 6 } }}>
          <Box
            aria-hidden
            sx={{
              display: 'grid',
              placeItems: 'center',
              width: 56,
              height: 56,
              mx: 'auto',
              mb: 2.5,
              borderRadius: '18px',
              backgroundColor: 'var(--qf-accent-soft)',
              color: 'var(--qf-accent)',
            }}
          >
            <FolderOpenRoundedIcon sx={{ fontSize: 28 }} />
          </Box>

          <Typography sx={{ ...TYPE.body, color: 'var(--qf-ink-2)', mb: 3.5, textWrap: 'pretty' }}>
            {t('projects.empty')}
          </Typography>

          <Button component={Link} to="/contact" variant="contained">
            {t('home.ctaAction')}
          </Button>
        </Panel>
      </Reveal>
    </Section>
  );
}
